import ENDPOINT from 'constants/endpoints';

import './styles.css';
import ERROR_FIELD from 'constants/error-fields';
import {Role} from 'helpers/user';
import useApi from 'hooks/useApi';
import {isArray} from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import React, {useMemo} from 'react';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import BasicDialog from 'scenes/Dialog/components/BasicDialog';
import DeleteAccountRequestFirstStepDialog from 'scenes/Dialog/components/DeleteAccountRequestFirstStepDialog';
import DeleteAccountRequestSecondStepDialog from 'scenes/Dialog/components/DeleteAccountRequestSecondStepDialog';
import DeleteAccountRequestUnsubscribeDialog from 'scenes/Dialog/components/DeleteAccountRequestUnsubscribeDialog';
import FormDialog from 'scenes/Dialog/components/FormDialog';
import ResponseErrorDialog from 'scenes/Dialog/components/ResponseErrorDialog';
import AccountDeleteReasonForm from 'scenes/Form/components/AccountDeleteReasonForm';
import CheckPasswordForm from 'scenes/Form/components/CheckPasswordForm';
import LinkButton from '../../components/LinkButton'
import {Event as GaEvent} from '../../components/Tracking';
import {ACCOUNT_UNSUBSCRIBE_MODE} from '../../constants/account'

const RequestDeleteAccount = props => {
  const { setSubmitting, user, formData, setFormData } = props;
  const api = useApi();
  const history = useHistory();

  const fields4unsubscribe = {
    EmailRecommendedSettings: null,
    DailyDigest: 'No',
    WeeklyDigest: 'No',
    ReceiveMessages: 'No',
    MonthlyNewsLetter: 'No',
    PlatformActivity: 'No',
    IsSubscribed: 'No',
    ReceiveCandidateResumeAlerts: 'No',
    JobMailingAlternateEmailActive: 'No',
    ReceiveCandidateActivityEmail: 'No',
    ReceiveCandidateActivityDailyEmail: 'No',
    ReceiveApplicationAlternate: 'No',
    ReceiveProcessDigestAlternate: 'No',
    ReceiveProcessDigest: 'No',
    receive_applic: 'No',
    processApplic: [],
    processApplicDigest: [],
    Unsubscribe: ACCOUNT_UNSUBSCRIBE_MODE.HARD
  };

  const fields4KeepingAnEyeOut = {
    IsSubscribed: 'Yes',
    ReceiveMessages: 'Yes',
    PlatformActivity: 'Yes',
    MonthlyNewsLetter: 'Yes',
    EmailRecommendedSettings:'keepingAnEyeOut',
    WeeklyDigest: 'Yes',
    DailyDigest: 'No',
    Unsubscribe: ACCOUNT_UNSUBSCRIBE_MODE.NO
  }

  const fields4OffTheMarket = {
    EmailRecommendedSettings: 'offTheMarket',
    DailyDigest: 'No',
    WeeklyDigest: 'No',
    PlatformActivity: 'No',
    IsSubscribed: 'No',
    Unsubscribe: ACCOUNT_UNSUBSCRIBE_MODE.OFF_MARKET
  }

  const [isGuest] = useMemo(() => [Role.isGuest(user)], [user]);

  const unsubscribe = async () => {
    setSubmitting(true);
    const data = cloneDeep(formData.fields);
    Object.keys(fields4unsubscribe).forEach(f => {
      data[f] = fields4unsubscribe[f];
    });
    if (!data.privacy.includes('7')) {
      data.privacy.push('7');
    }
    if (!data.privacy.includes('8')) {
      data.privacy.push('8');
    }
    return saveData(data);
  };
  const KeepingAnEyeOut = async () => {
    setSubmitting(true);
    const data = cloneDeep(formData.fields);
    Object.keys(fields4KeepingAnEyeOut).forEach(f => {
      data[f] = fields4KeepingAnEyeOut[f];
    });
    if (!data.privacy.includes('7')) {
      data.privacy.push('7');
    }
    return saveData(data);
  };
  const OffTheMarket = async () => {
    setSubmitting(true);
    const data = cloneDeep(formData.fields);
    Object.keys(fields4OffTheMarket).forEach(f => {
      data[f] = fields4OffTheMarket[f];
    });
    if (!data.privacy.includes('7')) {
      data.privacy.push('7');
    }
    return saveData(data);
  };
  const hideAccount = () => {
    setSubmitting(true);
    const data = cloneDeep(formData.fields);
    if (!data.privacy.includes('1')) {
      data.privacy.push('1');
    }
    return saveData(data);
  };

  const saveData = (data) => {
    const apiCall = new Promise((resolve, reject) => {
      api.post(ENDPOINT.FORM.SAVE.ACCOUNT_SETTINGS_CANDIDATE_NOTIFICATIONS, data, {
        handleError: response => {
          setSubmitting(false);
          reject(response);
        },
        handleSuccess: () => {
          setSubmitting(false);
          setFormData({
            ...formData,
            fields: data,
          });
          formData.fields = cloneDeep(data);
          resolve();
        },
        handleComplete: () => setSubmitting(false),
      });
    });
    return toast.promise(apiCall, {
      pending: {
        render() {
          return <p>Saving...</p>;
        },
        icon: false,
      },
      success: {
        render() {
          return <p>Your account settings have been updated.</p>;
        },
        // other options
        icon: '🟢',
      },
      error: {
        render({ data }) {
          const {
            data: { fields },
          } = data;
          if (fields) {
            const obj = {};
            for (let [key, value] of Object.entries(fields)) {
              const error = isArray(value) ? value[0] : value;
              obj[key] = ERROR_FIELD[error] || `${error}`;
            }
            return Object.values(obj).join('<br />');
          } else {
            // When the promise reject, data will contains the error
            return `${data.status}`;
          }
        },
      },
    });
  };

  const deleteAccount = async () => {
    const value = await FormDialog({
      modeless: false,
      compact: false,
      popupInnerStyles: { marginTop: '50px' },
      popupTitleStyles: { marginLeft: '30px' },
      title: 'Thanks for using GoBuyside and best wishes.',
      form: (actions, params) => (
        <AccountDeleteReasonForm actions={actions} params={{ ...params, value: [] }} />
      ),
    })
    await FormDialog({
      modeless: false,
      compact: true,
      popupInnerStyles: { marginTop: '50px' },
      form: (actions, params) => (
        <CheckPasswordForm actions={actions} params={params} />
      ),
    })
    setSubmitting(true);
    api.post(
      ENDPOINT.ACTION.ACCOUNT.DELETE_ACCOUNT,
      { ...value, Reason: value.Reason.join(', ') },
      {
        handleError: response => ResponseErrorDialog({ response }),
        handleSuccess: () => {
          setSubmitting(false);
          BasicDialog({
            withoutButtons: false,
            bodyRender:
              <>
                <p>Your account has been successfully deleted</p>
                <p>All your personal information will be removed from the database during 24 hours</p>
                <p>Thank you for being a part of our community! If you ever decide to return, please feel free to
                  sign up again. We`ll be here to welcome you back.</p>
              </>,
          });
          setTimeout(() => {
            document.location.href = '/logout';
          }, 10000);
        },
        handleComplete: () => setSubmitting(false),
      },
    );
  };
  const userIsSubscribed = () => {
    const data = cloneDeep(formData.fields);
    let isSubscribed = false;
    if (!data.privacy.includes('8')) isSubscribed = true;
    if (!data.privacy.includes('7')) isSubscribed = true;
    else {
      Object.keys(fields4unsubscribe).forEach(f => {
        if (data[f] === 'Yes') isSubscribed = true;
      });
    }
    return isSubscribed;
  };
  const deactivateAccount = async () => {
    await hideAccount();
    if (userIsSubscribed()) {
      const result = await DeleteAccountRequestUnsubscribeDialog()
      if (result) {
        await unsubscribe()
        GaEvent('screen_view', 'Delete Account - Deactivate & Unsubscribe', 'Delete Account - Deactivate & Unsubscribe')
        history.push('/candidate/account#notifications/candidate');
      } else {
        history.push('/candidate/account#notifications/candidate');
      }
    }
  };

  const requestDeleteAccount = async ({ setSubmitting }) => {
    setSubmitting(true);
    if (isGuest) {
      GaEvent('screen_view', 'Delete Account - Guest', 'Delete Account - Guest')
      deleteAccount();
    } else {
      GaEvent('screen_view', 'Delete Account clicked', 'Delete Account clicked')
      const firstStepResult = await DeleteAccountRequestFirstStepDialog();
      if (firstStepResult === 1) {
        GaEvent('screen_view', 'Delete Account - getting too many emails', 'Delete Account - getting too many emails')
        await KeepingAnEyeOut();
        history.push('/candidate/account#notifications/candidate');
        return;
      }
      if (firstStepResult === 2) {
        GaEvent('screen_view', 'Delete Account - off the job market', 'Delete Account - off the job market')
        await OffTheMarket();
        history.push('/candidate/account#notifications/candidate');
        return;
      }
      if (firstStepResult !== 3) {
        return;
      }
      const secondStepResult = await DeleteAccountRequestSecondStepDialog();
      if (secondStepResult === 1) {
        GaEvent('screen_view', 'Delete Account - Deactivate', 'Delete Account - Deactivate')
        await deactivateAccount();
      }
      if (secondStepResult === 2) {
        GaEvent('screen_view', 'Delete Account - Permanently delete', 'Delete Account - Permanently delete')
        await deleteAccount();
      }
    }
  };

  return (
    <div className="form__group" style={{ margin: '15px 0' }}>
      <div id={'delete_request'}>
        <LinkButton
          btnFontWeight={400}
          btnTextColor={"#27282d"}
          controlFunc={() => requestDeleteAccount({
            setSubmitting,
          })}
          text="Pause or Remove Account"
        />
      </div>
      <p id={'delete_request_message'} style={{ margin: '15px 0', display: 'none' }}>Thanks, your account deletion
        request has been submitted. We will get back to you shortly to confirm account deletion.</p>
    </div>
  );
};

export default RequestDeleteAccount;
